import { StyleSheet } from 'react-native';
import FontFamily from '../../../../constants/fonts';

export const msStyles = StyleSheet.create({
  container: { marginBottom: 4 },
  label: {
    fontSize: 14,
    fontWeight: '600',
    color: '#454545',
    marginBottom: 4,
    fontFamily: FontFamily.medium,
  },
  trigger: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderWidth: 1,
    borderColor: '#CED4DA',
    borderRadius: 5,
    paddingHorizontal: 12,
    paddingVertical: 10,
    backgroundColor: '#FFFFFF',
    minHeight: 42,
  },
  triggerText: { flex: 1, fontSize: 14, color: '#212529', fontFamily: FontFamily.regular },
  placeholder: { color: '#6C757D' },
  backdrop: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 },
  menu: {
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#CED4DA',
    borderRadius: 5,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 8,
    zIndex: 9999,
  },
  searchBox: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  searchInput: {
    flex: 1,
    fontSize: 13,
    color: '#212529',
    fontFamily: FontFamily.regular,
    paddingVertical: 2,
  },
  option: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#F0F0F0',
  },
  optionSelected: { backgroundColor: '#EAF4FF' },
  optionText: { fontSize: 14, color: '#212529', fontFamily: FontFamily.regular, flex: 1 },
});

export const sdStyles = StyleSheet.create({
  container: { marginBottom: 4 },
  label: {
    fontSize: 14,
    fontWeight: '600',
    color: '#454545',
    marginBottom: 4,
    fontFamily: FontFamily.medium,
  },
  trigger: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderWidth: 1,
    borderColor: '#CED4DA',
    borderRadius: 5,
    paddingHorizontal: 12,
    paddingVertical: 10,
    backgroundColor: '#FFFFFF',
    minHeight: 42,
  },
  triggerText: { flex: 1, fontSize: 14, color: '#212529', fontFamily: FontFamily.regular },
  placeholder: { color: '#6C757D' },
  backdrop: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 },
  menu: {
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#CED4DA',
    borderRadius: 5,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 8,
    zIndex: 9999,
  },
  searchBox: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  searchInput: {
    flex: 1,
    fontSize: 13,
    color: '#212529',
    fontFamily: FontFamily.regular,
    paddingVertical: 2,
  },
  option: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#F0F0F0',
  },
  optionSelected: { backgroundColor: '#EAF4FF' },
  optionText: { fontSize: 14, color: '#212529', fontFamily: FontFamily.regular, flex: 1 },
  emptyText: {
    textAlign: 'center',
    paddingVertical: 16,
    fontSize: 13,
    color: '#999',
    fontFamily: FontFamily.regular,
  },
});

export const styles = StyleSheet.create({
  overlayWrapper: { flex: 1, flexDirection: 'column' },
  scrollContent: { flex: 1 },
  overlayContent: { padding: 20 },
  overlayFooter: {
    flexDirection: 'column',
    paddingHorizontal: 20,
    paddingVertical: 16,
    // borderTopWidth: 1,
    // borderTopColor: '#E0E0E0',
    // backgroundColor: '#FFFFFF',
  },
  saveErrorBox: {
    // flexDirection: 'row',
    // alignItems: 'center',
    // backgroundColor: '#FFEBEE',
    // borderRadius: 4,
    // borderLeftWidth: 3,
    // borderLeftColor: '#C62828',
    // paddingHorizontal: 12,
    // paddingVertical: 8,
    // marginBottom: 12,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFEBEE',
    borderRadius: 4,
    borderLeftWidth: 3,
    borderLeftColor: '#C62828',
    paddingHorizontal: 12,
    paddingVertical: 8,
    marginHorizontal: 20,
    marginTop: 10,
    marginBottom: 2,
  },
  saveErrorText: { fontSize: 13, color: '#C62828', fontFamily: FontFamily.regular, flex: 1 },
  footerButtons: { flexDirection: 'row', justifyContent: 'flex-end', gap: 12 },

  // Status toggle
  statusRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
    paddingVertical: 10,
    paddingHorizontal: 14,
    backgroundColor: '#F5F9FF',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#D0D9E8',
  },
  statusLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#2D2D2D',
    fontFamily: FontFamily.medium,
    marginRight: 10,
  },
  statusValue: { fontSize: 14, fontWeight: '600', fontFamily: FontFamily.medium, marginLeft: 10 },

  // Section headers
  sectionTitleContainer: {
    borderBottomWidth: 2,
    borderBottomColor: '#DAEEFA',
    paddingBottom: 12,
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#2D2D2D',
    fontFamily: FontFamily.bold,
  },

  // Module Assignment
  moduleAssignmentSection: {
    backgroundColor: '#FFF9C4',
    borderRadius: 8,
    padding: 16,
    marginBottom: 20,
    borderLeftWidth: 4,
    borderLeftColor: '#F57F17',
    overflow: 'visible',
  },

  // Assessment Text
  assessmentSection: {
    flexDirection: 'column',
    marginBottom: 20,
    overflow: 'visible',
  },

  // Dynamic dropdown layout
  dynamicDropdownRow: {
    flexDirection: 'row',
    gap: 12,
    overflow: 'visible',
  },
  dynamicDropdownHalf: {
    flex: 1,
    overflow: 'visible',
  },
  dynamicDropdownFull: {
    width: '100%',
    overflow: 'visible',
  },

  autoFillHint: {
    fontSize: 11,
    color: '#888',
    fontFamily: FontFamily.regular,
    marginTop: 4,
    fontStyle: 'italic',
  },

  // Input fields
  inputGroup: { marginBottom: 12 },
  inputLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#2D2D2D',
    marginBottom: 8,
    fontFamily: FontFamily.medium,
  },
  greyText: { color: '#999999', fontWeight: '200' },
  labelRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 4,
  },
  fieldLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#2D2D2D',
    fontFamily: FontFamily.medium,
    flexShrink: 1,
  },
  requiredLabel: {
    fontSize: 12,
    color: 'rgb(108, 117, 125)',
    fontFamily: FontFamily.regular,
    marginLeft: 4,
  },
  inputWrapper: { borderWidth: 1, borderColor: '#D0D0D0', borderRadius: 5 },
  inputError: {
    borderColor: '#C62828',
    borderWidth: 1,
    backgroundColor: '#FFF5F5',
  },
  textInput: {
    fontSize: 12,
    color: '#2D2D2D',
    fontFamily: FontFamily.regular,
    paddingVertical: 6,
    paddingHorizontal: 10,
    minHeight: 80,
  },
  charCount: { fontSize: 10, color: '#999999', fontFamily: FontFamily.regular, marginTop: 2 },
  charCountRow: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 2 },
  inputLocked: { backgroundColor: '#F5F5F5', borderColor: '#D0D0D0' },
  lockedHelperText: { fontSize: 10, color: '#999999', fontFamily: FontFamily.regular, fontStyle: 'italic' },

  // Info banner
  infoBox: {
    backgroundColor: '#FFF8E1',
    borderRadius: 5,
    borderLeftWidth: 4,
    borderLeftColor: '#F4A012',
    padding: 12,
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginTop: 8,
  },
  infoIcon: { marginRight: 12, marginTop: 2, flexShrink: 0 },
  infoText: {
    fontSize: 13,
    color: '#7B5800',
    lineHeight: 20,
    fontFamily: FontFamily.regular,
    flex: 1,
  },

  // Shared Attributes
  sharedAttributesSection: { flexDirection: 'column', marginBottom: 20, overflow: 'visible' },
  dropdownRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 12,
    overflow: 'visible',
  },
  intInputLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#454545',
    marginBottom: 4,
    fontFamily: FontFamily.medium,
  },
  intInput: {
    borderWidth: 1,
    borderColor: '#CED4DA',
    borderRadius: 5,
    paddingHorizontal: 12,
    paddingVertical: 10,
    backgroundColor: '#FFFFFF',
    minHeight: 42,
    fontSize: 14,
    color: '#212529',
    fontFamily: FontFamily.regular,
  },
  dropdownColumn: { flex: 1, marginRight: 8, overflow: 'visible' },
  dropdownErrorWrapper: {
    borderWidth: 1,
    borderColor: '#C62828',
    borderRadius: 6,
    padding: 4,
    backgroundColor: '#FFF5F5',
  },
});
